export default function hotelProvider(providers) {
  const booking = providers ? providers.filter(provider =>
    provider.id.includes("bdc")
  ) : [];
  const hostelworld = providers ? providers.filter(provider =>
    provider.id.includes("hw")
  ) : [];

  if (booking.length) {
    return {
      type: "bdc",
      data: booking[0],
      name: "booking.com",
    };
  } else if (hostelworld.length) {
    return {
      type: "hostelworld",
      data: hostelworld[0],
      name: "Hostelworld",
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./assets/shared/hotelProvider.js